// extracted by mini-css-extract-plugin
export default {"button":"ButtonWhite_button__kj4yg"};